import { useAdmin } from "context/adminContext";
import { useMerchant } from "context/merchantContext";

const CheckPermission = ({ allow, children }) => {
  const { permissions } = useMerchant();
  const { adminId } = useAdmin();
  if (adminId) return children;
  if (permissions && permissions.includes(allow)) {
    return children;
  }
  return null;
};

export default CheckPermission;
